module.exports = __FOREMAN_VENDOR__HISTORY__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__HISTORY__"
// module id = history
// module chunks = 0 1 2